export var MuiCard = {
  styleOverrides: {
    root: function root(_ref) {
      var theme = _ref.theme;
      return {
        borderRadius: 14,
        borderColor: theme.palette.grey[300],
        'box-shadow': {
          xs: 'none',
          md: theme.shadows[1]
        }
      };
    }
  }
};
//# sourceMappingURL=MuiCard.js.map